/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SystemDropdownParameter = {
    Overbookable: 'Overbookable',
    AttendanceType: 'AttendanceType',
    Deletable: 'Deletable',
    Editable: 'Editable',
    SrvRegistered: 'SrvRegistered',
    Projected: 'Projected',
    IncomeTreatment: 'IncomeTreatment',
    AvailableInExchange: 'AvailableInExchange',
    Conversation: 'Conversation'
} as const;
export type SystemDropdownParameter = typeof SystemDropdownParameter[keyof typeof SystemDropdownParameter];


export function instanceOfSystemDropdownParameter(value: any): boolean {
    for (const key in SystemDropdownParameter) {
        if (Object.prototype.hasOwnProperty.call(SystemDropdownParameter, key)) {
            if (SystemDropdownParameter[key as keyof typeof SystemDropdownParameter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SystemDropdownParameterFromJSON(json: any): SystemDropdownParameter {
    return SystemDropdownParameterFromJSONTyped(json, false);
}

export function SystemDropdownParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemDropdownParameter {
    return json as SystemDropdownParameter;
}

export function SystemDropdownParameterToJSON(value?: SystemDropdownParameter | null): any {
    return value as any;
}

export function SystemDropdownParameterToJSONTyped(value: any, ignoreDiscriminator: boolean): SystemDropdownParameter {
    return value as SystemDropdownParameter;
}

